import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI } from '@/services/BackendAPI.js';

export default {
  all(data = {}) {
    return BackendAPI('get', ApiRoutes.school.all(), data);
  },
  videoViewings(id) {
    return BackendAPI('get', ApiRoutes.school.videoViewings(id));
  },
  get(id) {
    return BackendAPI('get', ApiRoutes.school.get(id));
  },
  create(data) {
    return BackendAPI('post', ApiRoutes.school.create(), data);
  },
  update(id, data) {
    return BackendAPI('put', ApiRoutes.school.update(id), data);
  },
  changePassword(id, password) {
    let passData = { password: password };
    return BackendAPI('put', ApiRoutes.school.changePassword(id), passData);
  },
  frozen(id, data = {}) {
    return BackendAPI('put', ApiRoutes.school.frozen(id), data);
  },
  validateId(id) {
    return BackendAPI('get', ApiRoutes.school.validateId(id));
  },
};
